import type { ProgressNotificationRepository } from '@/domains/ui/progressNotification.repository';
import { BaseNotificationService } from './baseNotification.service';

/**
 * Servicio específico para notificaciones de progreso usando SweetAlert2
 * Cumple con SRP: única responsabilidad es mostrar indicadores de progreso
 * Usa servicio base para eliminar duplicación de configuración
 */
class ProgressNotificationService
  extends BaseNotificationService
  implements ProgressNotificationRepository
{
  /**
   * Muestra notificación de progreso con timer automático
   * @param message - Mensaje de progreso a mostrar (ej: "Procesando...")
   */
  async showProgress(message: string): Promise<void> {
    await this.showNotification(message, BaseNotificationService.CONFIGS.INFO);
  }
}

export const progressNotificationService = new ProgressNotificationService();
